import { Rowing } from "@mui/icons-material";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import React from "react";
import { currency } from "../../../MUI_components/currencyFormatterTag";

export default function SalesReturnTable(props: any) {
  const { data, returnedData } = props;

  let status:string;

  if(data.paidStatus == "1"){
    status = "Unpaid, You can't return credit bill items "
  }else if (data.paidStatus == "2"){
    status = "Partial Payment"
  }else {
    status = "Paid"
  }

  return (
    <Paper style={{ padding: 10 }}>
      {data && data.stockHistories ? (
        <>
          <div className="mt mb">
            <Typography variant="body2">
              <b>Customer: </b>
              {data.customer ? data.customer.firstName : "Cash Customer"}
            </Typography>
            <Typography variant="body2">
              <b>Invoice Number: </b>
              {data.code}
            </Typography>

            <Typography variant="body2">
              <b>Date & Time: </b>
              {data.dateTime}
            </Typography>
            <Typography
              variant="body2"
              //style={{ color: data.paidStatus  ? "green" : "crimson" }}
              style={{ color: data.paidStatus == "1"  ? "crimson" : "green" }}
            >
              <b>Paid Status: </b>
              {status}
              {/* {data.paidStatus ? "Paid" : "Unpaid"} */}
            </Typography>
          </div>
          <TableContainer>
            <Table size="small" aria-label="spanning table">
              <TableHead style={{ backgroundColor: "#cacaca50" }}>
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    Details
                  </TableCell>
                  <TableCell align="right">Price</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width="5">#</TableCell>
                  <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.QUANTITY}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.RETAIL_PRICE}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.DISCOUNT_AMOUNT}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.UNIT_SOLD_PRICE}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.TOTAL}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.stockHistories.map((row: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell width="5">{index + 1}</TableCell>
                    <TableCell>{row.itemMaster.name}{row?.warrantyDetails ? ` | Warranty: ${row?.warrantyDetails?.warrantyPeriod}` : ''}{row?.serialNumber ? ` | S/N: ${row.serialNumber}` : ''}</TableCell>
                    <TableCell align="right">{row.quantity}</TableCell>
                    <TableCell align="right">{row.retailPrice}</TableCell>
                    <TableCell align="right">{row.discountPercentage}</TableCell>
                    <TableCell align="right">{row.discountAmount}</TableCell>
                    <TableCell align="right">{ currency(
                                                (Number(row?.retailPrice) || 0) -
                                                (
                                                  (Number(row?.discountAmount) || 0) +
                                                  (((Number(row?.discountPercentage) || 0) / 100) * (Number(row?.retailPrice) || 0))
                                                )
                                              )
                                              }
                    </TableCell>
                    <TableCell align="right">{currency(row.totalAmount)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableHead>
                {data.length === 0 ? (
                  <TableRow>
                    <TableCell align="center" colSpan={8}>
                      No Data
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    <TableRow>
                      <TableCell colSpan={6} rowSpan={3} />
                      <TableCell>{COLUMNS_NAME.SUB_TOTAL}</TableCell>
                      <TableCell align="right">
                        {currency(data.subTotalAmount)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{COLUMNS_NAME.DISCOUNT}</TableCell>
                      <TableCell align="right">
                        {currency(data.discountTotal)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{COLUMNS_NAME.TOTAL}</TableCell>
                      <TableCell align="right">
                        {currency(data.totalAmount)}
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </TableHead>
            </Table>
          </TableContainer>

          
          <div className="mt mb">
            {returnedData.map((raw:any)=>(
              <div>
              <Typography variant="body2">
              <b>{COLUMNS_NAME.DATE} </b>
              {raw.returnDateTime}
            </Typography>
            <Typography variant="body2">
              <b>{COLUMNS_NAME.TOTAL} </b>
              {raw.totalAmount}
            </Typography>

            <Table size="small" aria-label="spanning table">
              <TableHead style={{ backgroundColor: "#cacaca50" }}>
                <TableRow>
                  <TableCell align="center" colSpan={6}>
                    Details
                  </TableCell>
                  <TableCell align="right">Price</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width="5">#</TableCell>
                  <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.QUANTITY}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.UNIT_PRICE}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.DISCOUNT_AMOUNT}</TableCell>
                  <TableCell align="right">{COLUMNS_NAME.TOTAL}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {raw.stockHistories.map((stockHistories: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell width="5">{index + 1}</TableCell>
                    <TableCell>{stockHistories.itemMaster.name}</TableCell>
                    <TableCell align="right">{stockHistories.quantity}</TableCell>
                    <TableCell align="right">{stockHistories.unitSoldPrice}</TableCell>
                    <TableCell align="right">{stockHistories.discountPercentage}</TableCell>
                    <TableCell align="right">{stockHistories.discountAmount}</TableCell>
                    <TableCell align="right">{currency(stockHistories.totalAmount)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
              </Table>
           
              </div>
             

            ))}
            
          </div>
        </>
      ) : (
        <div
          className="flex justify-content-center fullWidth "
          style={{
            padding: 30,
          }}
        >
          {data === null ? "Invoice not found" : "No Data"}
        </div>
      )}
       
    </Paper>
  );
}
